import React from "react";

const AskREC = () => {
  return <div>AskREC</div>;
};

export default AskREC;
